const mainColumns: Record<string, string[]> = {
  '/appeals': [
    'id',
    'stage',
    'created_at',
    'manager_name',
    'name',
    'phone',
    'address',
    'source_appeal',
  ],
  '/orders': [
    'id',
    'stage',
    'production_number',
    'process_progress',
    'manager_name',
    'name',
    'phone',
    'address',
    'products_total',
    'debt',
  ],
  '/call-center/new-clients': ['id', 'name', 'phone', 'email', 'brand_name', 'office_name'],
  '/tasks': ['card_id', 'stage', 'task_type', 'task', 'deadline', 'name', 'responsible'],
  '/measurements': [
    'parent_id',
    'stage',
    'measurement_date',
    'measurement_time',
    'responsible',
    'address',
    'name',
    'phone',
  ],
  '/montage': [
    'id',
    'stage',
    'production_number',
    'montage_date',
    'responsible',
    'address',
    'name',
    'phone',
  ],
  '/logistics/deliveries': [
    'id',
    'stage',
    'order_reference',
    'delivery_date',
    'dealer',
    'customer_location_address',
    'capacity',
    'volume',
    'vehicle',
  ],
  '/logistics/route-sheets': [
    'id',
    'date',
    'vehicle',
    'driver_name',
    'orders_count',
    'unique_addresses_count',
    'total_weight',
    'total_volume',
  ],
  '/claims': [
    'id',
    'stage',
    'created_at',
    'claim_responsible',
    'num_tech',
    'name',
    'phone',
    'claim',
  ],
  '/claims-requests': ['id', 'stage', 'created_at', 'num_tech', 'name', 'phone', 'claim'],
  '/claims-works': [
    'id',
    'stage',
    'responsible_name',
    'engineers_name',
    'date_work_completion',
    'address',
    'claim',
  ],
  '/procurement': ['Номер', 'Дата', 'ПлановаяДатаДоставки', 'Поставщик', 'Сумма', 'Состояние'],
  '/warehouse': ['Номер', 'Дата', 'Поставщик', 'Сумма', 'НомерЗаказа', 'ЕстьРасхождения'],
  '/procurement/requests': [
    'Номер',
    'Дата',
    'ПлановаяДатаДоставки',
    'Название',
    'Поставщик',
    'Сумма',
    'Статус',
    'НомерЗаказа',
  ],
}

export const getMainColumnKeys = (settingsKey: string, availableKeys: string[]) => {
  const configured = mainColumns[settingsKey]?.filter(key => availableKeys.includes(key))
  if (!configured?.length) return availableKeys
  if (availableKeys.includes('operation') && !configured.includes('operation')) {
    return [...configured, 'operation']
  }
  return configured
}
